/**
 * Collection works-per-page: 30 · 60 · 90.
 * Persists in sessionStorage and keeps filters/sort via the URL `ps` param.
 */
(function () {
  var KEY = "af-coll-ps";
  var root = document.querySelector("[data-coll-page]");
  var group = document.querySelector("[data-coll-page-size]");
  if (!root || !group) return;

  var allowed = { 30: true, 60: true, 90: true };

  function readStored() {
    try {
      var n = parseInt(sessionStorage.getItem(KEY), 10);
      if (allowed[n]) return n;
    } catch (e) {}
    return 60;
  }

  function writeStored(n) {
    try {
      sessionStorage.setItem(KEY, String(n));
    } catch (e) {}
  }

  function urlPs() {
    try {
      var n = parseInt(new URLSearchParams(window.location.search).get("ps"), 10);
      if (allowed[n]) return n;
    } catch (e) {}
    return 0;
  }

  function navigate(n, resetPage) {
    var url = new URL(window.location.href);
    if (n === 60) url.searchParams.delete("ps");
    else url.searchParams.set("ps", String(n));
    if (resetPage) url.searchParams.delete("page");
    var next = url.pathname + url.search + url.hash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next === current) return;
    window.location.assign(next);
  }

  var stored = readStored();
  var fromUrl = urlPs();
  if (!fromUrl && stored !== 60) {
    navigate(stored, false);
    return;
  }

  group.addEventListener("click", function (event) {
    var btn = event.target.closest("[data-coll-ps]");
    if (!btn || !group.contains(btn)) return;
    var next = parseInt(btn.getAttribute("data-coll-ps"), 10);
    if (!allowed[next]) return;
    writeStored(next);
    if (next === (fromUrl || 60)) return;
    navigate(next, true);
  });
})();
